/**
 * 共通関数はこのファイルに定義する
 */
export const utils = {
  methods: {
    /**
     * Collapse the given text
     * @param {STRING} text     target text
     * @param {INTEGER} length  the length of the text which be collapsed
     * @returns STRING
     */
    collapseText: function (text, length) {
      if (!text || text.length < length) return text;
      return text.substring(0, 7) + '・・・';
    },
    numberOnly: function (number) {
      return /^[0-9]*$/.test(number);
    },
    isPhoneNumber: function (phoneNumber) {
      return this.numberOnly(phoneNumber) && (phoneNumber.length === 10 || phoneNumber.length === 11);
    },
  },

  // For Trial
  chkTrialCompanyID: companyID => {
    if (companyID && companyID.match(/^tri[0-9]{6}$/)) {
      return true;
    }
    return false;
  },
  // #3249 add description tag to meta
  setMetaDescription: route => {
    function setMetaDescriptionReal(descreptionText) {
      if (document.querySelector("meta[name='description']")) {
        document.querySelector("meta[name='description']").setAttribute('content', descreptionText);
      }
    }
    if (route.meta.desc) {
      setMetaDescriptionReal(route.meta.desc);
    } else {
      setMetaDescriptionReal('');
    }
  },
  setMetaDescription2: route => {
    function setMetaDescriptionReal(descreptionText) {
      if (document.querySelector("meta[name='description']")) {
        document.querySelector("meta[name='description']").setAttribute('content', descreptionText);
      }
    }
    if (route.meta.desc2) {
      setMetaDescriptionReal(route.meta.desc2);
    } else {
      setMetaDescriptionReal('');
    }
  },
};
